module.exports = "/_next/static/images/chest-card-13bf8efa4f4c93a3248a2e34b6298fcb.png";